import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import PhoneCodeList from "./_list";
import PhoneCodeForm from "./_form";
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const PhoneCode = props => {
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    // Modo de vista: LIST, FORM
    const [viewMode, setViewMode] = useState("LIST")

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const updateItem = (item) => setItem(item)

    return (<>
        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    {
                        viewMode === "LIST" ?
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                            </div> : null
                    }
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="12">
                {(
                    function() {
                        switch (viewMode) {
                            case "LIST" :
                                return <PhoneCodeList
                                    setForm={setForm}
                                    app={props.app}
                                />
                            case "FORM" :
                                return <PhoneCodeForm
                                    setForm={setForm}
                                    updateItem={updateItem}
                                    item={item}
                                    editMode={editMode}
                                    app={props.app}
                                />
                            default:
                                return null;
                        }
                })()}
            </Col>
        </Row>
    </>);
}

export default PhoneCode
